module.exports = __webpack_public_path__ + "img/Flag_of_Bhutan.ce4684f2.svg";